import { DoubleLeftOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";

const JobTimelineDrawer = ({ isOpen, onClose, children }) => {
  if (!isOpen) {
    return null;
  }
  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-10 z-40" onClick={onClose} />
      <div
        className={`
          fixed right-0 bg-white
          shadow-2xl
          transition-transform duration-300 ease-in-out
          z-50
          translate-x-0
        `}
        style={{
          width: "550px",
          top: "150px",
          height: "calc(100% - 260px)",
          borderTopLeftRadius: "30px",
          borderBottomLeftRadius: "30px",
          boxShadow: "-5px 0 20px rgba(0,0,0,0.1)",
        }}
      >
        <div className="flex items-center px-6 pt-6 border-b-0">
          <DoubleLeftOutlined onClick={onClose} className="cursor-pointer text-gray-500 text-2xl hover:text-gray-700 transition-colors" />
        </div>
        <div className="px-10 overflow-y-auto" style={{ height: "calc(100% - 80px)" }}>
          {children}
        </div>
      </div>
    </>
  );
};

JobTimelineDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default JobTimelineDrawer;
